import { requestWithToken } from '../../utilities/request';

/**
 * ユーザー情報を取得
 * */
const fetch = userId => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/users/${userId}`,
  });
};

/**
 * ユーザ登録
 *
 * @param {object} data：更新データ
 */
const create = data => {
  return requestWithToken({
    method: 'POST',
    url: '/api/private/users',
    headers: { 'content-type': 'multipart/form-data' },
    data,
  });
};

/**
 * ユーザー顔画像を取得
 * */
const faceImage = userId => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/users/${userId}/image`,
  });
};

export const UserApi = {
  fetch,
  create,
  faceImage,
};

export default UserApi;



// WEBPACK FOOTER //
// ./src/services/user/UserApi.js